import GraphicsLayerView from "@arcgis/core/views/layers/GraphicsLayerView";
import { GraphicsLayer, MapView, SimpleLineSymbol } from "cd-eft/utils/esriTypes";
import { MapViewInputCursor } from "../framework/MapViewInputTask";

export async function onExecuteBreaklineOperation(task, breaklinesLayer, breaklinesSyncSet, spatialReference): Promise<void> {
    const result = await task.executeTaskAsync();

    // redraw graphics layer
    breaklinesLayer.removeAll();
    for (const bl of breaklinesSyncSet.getItems()) {
        breaklinesLayer.add(bl.generateGraphic(spatialReference));
    }
    return; 
}

export async function onCancelBreaklineOperation(task): Promise<void> {
    if (task.isExecuting) {
        await task.cancelTaskAsync();
    }
}

export async function onPickPointerMove(e: __esri.ViewPointerMoveEvent, tempHighlightLayer, tempLayer, mapView, __highlightHandle): Promise<void> {
    tempHighlightLayer.removeAll();

    const options: __esri.MapViewHitTestOptions = {};
    options.include = tempLayer;

    const result = await mapView.hitTest(e, options);
    if (__highlightHandle) {
        __highlightHandle.remove();
        __highlightHandle = undefined;
    }
    if (result.results[0]) {
        const graphic = result.results[0].graphic;
        for (const layerView of mapView.allLayerViews) {
            if (layerView.layer === graphic.layer) {
                __highlightHandle = (layerView as GraphicsLayerView).highlight(graphic);
            }
        }
    }
}

export function onBreaklineSetup(cursor: MapViewInputCursor, __highlightHandle, tempBreaklinesLayer, tempHighlightLayer, breaklines, mapView): void {
    if (__highlightHandle) {
        __highlightHandle.remove();
        __highlightHandle = undefined;
    }

    tempBreaklinesLayer.removeAll();
    tempHighlightLayer.removeAll();

    for (const breakline of breaklines) {
        const graphic = breakline.generateGraphic(mapView.spatialReference);
        graphic.symbol = new SimpleLineSymbol({ width: 3, color: 'red' });
        tempBreaklinesLayer.add(graphic);
    }

    mapView.map.add(tempBreaklinesLayer);
    mapView.map.add(tempHighlightLayer);
}

export function onToolCleanup(__highlightHandle, tempToolLayer: GraphicsLayer, mapView: MapView, tempHighlightLayer?): void {
    if (__highlightHandle) {
        __highlightHandle.remove();
        __highlightHandle = undefined;
    }

    mapView.map.remove(tempToolLayer);
    tempToolLayer.removeAll();

    if (tempHighlightLayer) {
        mapView.map.remove(tempHighlightLayer);
        tempHighlightLayer.removeAll();
    }
}
